import React from "react";
import { Link, useNavigate } from "react-router";
import ChevronRightIcon from "../Icons/ChevronRightIcon";
import ChevronLeftIcon from "../Icons/ChevronLeftIcon";

interface Crumb {
  name: string;
  clickFunc?: Function;
  url?: string;
}

interface Props {
  crumbs: Array<Crumb>
}


const LocalBreadcrumbs = (props: Props) => {

  const previousPage = useNavigate();

  const formatLink = (crumb: Crumb) => {
    if (crumb.clickFunc) {
      return (
        <div className="hover:text-primary-500 cursor-pointer"
             onClick={() => crumb.clickFunc ? crumb.clickFunc() : alert("Missing click")}>
          {crumb.name}
        </div>
      )
    } else if (crumb.url) {
      return (
        <Link to={crumb.url} className="hover:text-primary-500">
          {crumb.name}
        </Link>
      )
    } else {
      return (
        <div className="hover:text-primary-500">
          {crumb.name}
        </div>
      )
    }
  }

  const handleBackLink = () => {
    if (props.crumbs.length > 1) {
      const crumb = props.crumbs[props.crumbs.length - 2];
      if (crumb.clickFunc) {
        crumb.clickFunc();
      } else if (crumb.url) {
        previousPage(crumb.url);
      } else {
        previousPage(-1);
      }
    } else {
      previousPage(-1);
    }
  }

  return (
   <nav aria-label="breadcrumb" className="mt-6">
  <div className="flex flex-col justify-start align-middle w-full desktop:w-151">
    <div className="flex items-center md:hidden">
      {/* Mobile view */}
      <ChevronLeftIcon
        aria-label="Back"
        onClick={() => handleBackLink()}
        className="h-4 w-4 mx-1.5 cursor-pointer text-white!"
      />
      <span className="z-body3">
          {/* Last item */}
        {props.crumbs[props.crumbs.length - 1]?.name}
        </span>
    </div>

    <ol className="hidden md:flex flex-wrap items-center text-gray-400 text-xs">
      {props.crumbs.map((crumb, index) => (
        <li key={index} className="flex items-center">
          {index > 0 && (
            <ChevronRightIcon className="w-4 h-4 mx-1.5 text-neutral-400!" aria-hidden="true" />
          )}
          {formatLink(crumb)}
        </li>
      ))}
    </ol>
  </div>
</nav>
  );
};

export default LocalBreadcrumbs;
